// extracted by mini-css-extract-plugin
export default {"option":"UpdateDepositRate_option__f4U7M"};